var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxingGlove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36445 7.41317C4.20485 7.88759 3 9.01964 3 11.3721C3 13.809 4.93009 15.462 6.41937 16.2725L5.70875 13.0068C5.33561 11.2921 5.21062 9.53396 5.3375 7.78473L5.36445 7.41317Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91394 9.54228L6.97152 10.563C6.94195 10.2235 6.92274 9.88306 6.91394 9.54228Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01795 6.99204C7.19335 4.57389 9.02824 2.58893 11.4566 2.19037C13.0032 1.93654 14.5817 1.93654 16.1283 2.19037L16.5219 2.25497C18.7524 2.62105 20.4852 4.36761 20.805 6.57204L20.8265 6.72002C21.1697 9.08628 21.0025 11.4972 20.3357 13.7956L19.1887 17.7488H8.3962L7.29164 12.6728C6.95048 11.105 6.83621 9.49761 6.95221 7.89831L7.01795 6.99204ZM16.5812 7.78417C16.9532 8.02836 17.4557 7.92938 17.7037 7.5631C17.9516 7.19681 17.8511 6.70192 17.4792 6.45773C15.2467 4.99209 12.3382 4.99209 10.1057 6.45773C9.73374 6.70192 9.63323 7.19681 9.8812 7.5631C10.1292 7.92938 10.6318 8.02836 11.0037 7.78417C12.6924 6.67552 14.8925 6.67552 16.5812 7.78417Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1887 19.6087H8.39624V19.8744C8.39624 21.0483 9.36263 22 10.5547 22H17.0302C18.2223 22 19.1887 21.0483 19.1887 19.8744V19.6087Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxingGlove);
export default __webpack_public_path__ + "static/media/boxing-glove.d48a820aee15cf69cc33baba26ed13e9.svg";
export { ForwardRef as ReactComponent };